import { AdvertisingGetAdPageType } from "@/hooks/api/generated";

export enum AllowedPages {
  JobsDetail = "/jobs/",
  Jobs = "/jobs",
  EventsDetail = "/events/",
  Events = "/events",
  NewsDetail = "/news/",
  News = "/news",
}

/**
 * Maps allowed paths to the corresponding ad pageType for the API
 */
export const PageTypeMap: Record<AllowedPages, AdvertisingGetAdPageType> = {
  [AllowedPages.Jobs]: AdvertisingGetAdPageType.job_listing,
  [AllowedPages.JobsDetail]: AdvertisingGetAdPageType.job_details,
  [AllowedPages.Events]: AdvertisingGetAdPageType.event_listing,
  [AllowedPages.EventsDetail]: AdvertisingGetAdPageType.event_details,
  [AllowedPages.News]: AdvertisingGetAdPageType.news_listing,
  [AllowedPages.NewsDetail]: AdvertisingGetAdPageType.news_article,
};
